import { getIconAsSvgString } from "./icon.js";
const fallbackThemes = {
  inactive: {
    foreground: "#fff",
    background: "#6e757d"
  },
  inactiveHighlight: {
    foreground: "#fff",
    background: "#2B2E31"
  }
};
const Pin = ({ width: defaultWidth = 40, height: defaultHeight = 47, themes }) => (props) => {
  const { primary: primaryTheme, highlight: highlightTheme, hovered: hoveredTheme } = themes;
  const { highlight = false, hovered = false, inactive = false } = props;
  let theme = primaryTheme;
  if (inactive) {
    if (highlight && themes?.inactiveHighlight) {
      theme = themes?.inactiveHighlight || fallbackThemes.inactiveHighlight;
    } else if (themes?.inactive) {
      theme = themes?.inactive || fallbackThemes.inactive;
    }
  } else if (highlight && highlightTheme) {
    theme = highlightTheme;
  } else if (hovered && hoveredTheme) {
    theme = hoveredTheme;
  }
  const width = theme.width || defaultWidth;
  const height = theme.height || defaultHeight;
  const anchor = { x: Math.round(width / 2), y: height };
  const size = { width, height };
  const svgString = getIconAsSvgString(width, height, theme);
  return {
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`,
    anchor,
    size,
    scaledSize: size
  };
};
export {
  Pin as default
};
//# sourceMappingURL=Pin.js.map
